import { useMemo } from 'react';
import { useField } from 'formik';
import { Input } from 'components';
import { HeadCell } from 'components/gifts-table/TableList';
import { getAmountCellInputName } from 'util/forms';
import './styles.scss';

export default function AmountCell(props) {
  const { id = 0, isBody } = props;

  const cellName = useMemo(() => getAmountCellInputName(id), [id]);

  const [, , helpers] = useField(cellName);

  const handleClickDelete = () => {
    helpers.setValue(0);
  };

  return (
    <>
      {isBody ? (
        <td className="AmountCell">
          <Input
            name={cellName}
            inputMode="numeric"
            pattern="\d*"
            className="AmountCell__Input"
            containerClassName="d-flex justify-content-center"
            maxLength={4}
          />
          <div
            className="AmountCell__DeleteButton"
            role="button"
            tabIndex="0"
            onClick={handleClickDelete}
            onKeyPress={handleClickDelete}
          >
            <span className="text-primary">Eliminar</span>
          </div>
        </td>
      ) : (
        <HeadCell column={props} />
      )}
    </>
  );
}
